/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Password_Reset_FailedInputs */

const nl_auth_api_errors_password_reset_failed = /** @type {(inputs: Auth_Api_Errors_Password_Reset_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord resetten is mislukt`)
};

/**

* @param {Auth_Api_Errors_Password_Reset_FailedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_password_reset_failed = /** @type {((inputs?: Auth_Api_Errors_Password_Reset_FailedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Password_Reset_FailedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_password_reset_failed(inputs)
});
export { auth_api_errors_password_reset_failed as "auth.api_errors.password_reset_failed" }